/**
 * Build information utilities for cache-busting and version tracking
 */

declare global {
  const __BUILD_TIME__: string;
  const __APP_VERSION__: string;
  const __BUILD_HASH__: string;
}

export interface BuildInfo {
  buildTime: string;
  version: string;
  buildHash: string;
  deployEnv: string;
}

/**
 * Get build information for cache-busting and debugging
 */
export const getBuildInfo = (): BuildInfo => {
  return {
    buildTime:
      typeof __BUILD_TIME__ !== "undefined"
        ? __BUILD_TIME__
        : new Date().toISOString(),
    version: typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev",
    buildHash: typeof __BUILD_HASH__ !== "undefined" ? __BUILD_HASH__ : "dev",
    deployEnv: import.meta.env.VITE_DEPLOY_ENV || "dev"
  };
};

/**
 * Generate a cache-busting query parameter
 */
export const getCacheBuster = (): string => {
  const buildInfo = getBuildInfo();
  return `v=${buildInfo.version}&h=${buildInfo.buildHash}`;
};

/**
 * Add cache-busting parameters to a URL
 */
export const addCacheBuster = (url: string): string => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${getCacheBuster()}`;
};

/**
 * Log build information to console (useful for debugging deployments)
 */
export const logBuildInfo = (): void => {
  const buildInfo = getBuildInfo();
  console.info(`
                                                                                                                             
        ####                                                                                                                 
     ##########                                                                                                              
  ######## #######            #######                                                     ####                   ####        
#########  #########         ###########                                                  ####                   ####        
########    #########        ####   ######  ##   #    ####       ###      #  ###    ###   #### ###     #      #  #### ###    
#######      ########        ####     ############ #########  ######### ################# ########## ####   #### ########### 
######        #######        ####      ########## #####  #### ###   ### #####  ####+ #### #####  ########   #### #####  #####
#####          ######        ####      ###+####   ########### ######### ####   ####   ### ####   ########   #### ####    ####
###              ####        ####    ##### ####   ####       #####  ### ####   ####   ### ####   ####+###+  #### ####    ####
#####################        ############  ####    #################### ####   ####   ### ####   #### ########## ########### 
 ##################          #########      ###     ########  #########  ###   ####   ### ####   ####  ######### ##########  
    ###########+                                                                                                             
       ######                Version: ${import.meta.env.MODE === "production" ? buildInfo.version : "dev"}
                             http://dreamhub.ai`);
};
